<template>
  <div class="f-signCaption">
    <div class="title-container"><h1>{{activeLanguage.whySign}}</h1></div>
    <div id="captionText">
      <p class="subtitle">{{activeLanguage.captionTitleSign}}</p>
      <p>{{activeLanguage.captionText.p1}}</p>
      <ul>
        <li v-for="(reason, idx) in activeLanguage.captionText.reasons" :key="idx">
          {{reason}}
        </li>
      </ul>
      <p>{{activeLanguage.captionText.p2}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SignCaption',
    computed: {
      activeLanguage () {
        let currLang = this.$translations[this.$store.getters.currentLanguageValue]
        if (currLang.captionText) {
          return this.$translations[this.$store.getters.currentLanguageValue]
        } else {
          return this.$translations['English']
        }
      }
    }
  }
</script>

<style scoped>

  #captionText {
    text-align: justify;
    margin-left: 10%;
    margin-right: 10%;
    padding-top: 2%;
  }

  .img-placeholder {
    width: 100px;
    width: 50px;
    background-color: #7f7f7f;
  }

  ul {
    list-style: none;
  }

  ul li::before {
    content: "\2022";
    color: #c41c21;
    font-weight: bold;
    display: inline-block;
    width: 1em;
    margin-left: -1em;
  }

  .subtitle {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/signPetitionPageComponents/SignCaption.vue